import { ConnectButton } from '@rainbow-me/rainbowkit'
import Box from '@/components/primitives/Box'
import Button from '@/components/primitives/Button'
import { FC } from 'react'

type Props = {}

export const ConnectWalletButton: FC<Props> = () => {
  return (
    <ConnectButton.Custom>
      {({ account, chain, openConnectModal, mounted }) => {
        return (
          <Box 
            className='btn-primary' 
          >
            {(() => {
              if (!mounted || !account || !chain) {
                return (
                  <Button   
                    css={{ flex: 1, justifyContent: 'center',  width: '100%' }}
                    corners="rounded"
                    onClick={openConnectModal}
                    type="button"
                  >
                    Connect Wallet
                  </Button>
                )
              }
            })()}
          </Box>
        )
      }}
    </ConnectButton.Custom>
  )
}
